<template>
  <div class="price">
    <!-- <h3 class="general__block-title text-h5" v-html="$t('product.admetox.priceBlockTitle')"></h3> -->
    <div class="price__wrapper">
      <div v-if="+priceDetails.itemGrossPrice.value" class="price__container">
        <div class="price__list">
          <div
            class="price__item"
            :class="{
              'price__item--border': !priceDetails.customerDiscountPercent,
            }"
          >
            <h5
              class="text-color-navy price__title text-h4"
              v-html="$t('product.prices.linePrice')"
            />
            <p
              class="text-color-navy price__value text-h4"
              v-html="priceDetails.itemGrossPrice.formattedValue"
            />
          </div>
          <div v-if="priceDetails.customerDiscountPercent" class="price__item price__item--border">
            <div>
              <h5
                class="text-color-navy price__title text-h4"
                v-html="$t('product.prices.lineDiscount')"
              />
              <span
                class="price__title-sublabel"
                v-html="$t('product.prices.lineDiscountSublabel')"
              />
            </div>
            <p class="price__value text-h4" v-html="priceDetails.itemNetPrice.formattedValue" />
          </div>
          <div class="price__item price__item--total">
            <h5
              class="text-color-navy price__title text-h4"
              v-html="$t('product.prices.lineTotal')"
            />
            <p class="text-color-navy price__value text-h4" v-html="totalPrice" />
            <p
              v-if="priceDetails.isPositiveCustomerDiscount && savedSum"
              class="text-color-navy price__discount-copy text-h4"
              v-html="`${$t('product.admetox.discountCopy')} ${savedSum}`"
            />
          </div>
        </div>
        <div class="price__info">
          <div
            v-if="priceDetails.isPositiveCustomerDiscount && priceDetails.customerDiscountPercent"
            class="price__info-item price__info-item--discount"
            v-html="`~ ${priceDetails.customerDiscountPercent}% off`"
          />
        </div>
      </div>
      <div v-if="!isLoggedIn" class="price__copy">
        <p
          v-if="!activeSku.code"
          class="price__copy--guest"
          v-html="$t('product.admetox.nonSelectedProductCopy')"
        />
        <p v-else class="price__copy--guest">
          <router-link to="/authentication">
            {{ $t('common.login') }}
          </router-link>
          {{ $t('product.admetox.guestCopy') }}
        </p>
      </div>
      <p
        v-if="isLoggedIn && priceCopy"
        class="price__copy price__copy--inline"
        v-html="priceCopy"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductDetailsPriceDetails',
  props: {
    priceDetails: {
      type: Object,
      required: true,
    },
    totalPrice: {
      type: String,
      required: true,
      default: '',
    },
    savedSum: {
      type: String,
      required: true,
      default: '',
    },
    priceCopy: {
      type: String,
      required: true,
      default: '',
    },
    activeSku: {
      type: Object,
      required: true,
    },
    isLoggedIn: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
